var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('h2',[_vm._v("Melding:")]),_c('score-calculator',{on:{"update":function($event){_vm.score = $event}}}),_c('hr'),_c('h2',[_vm._v("Takst:")]),_c('p',[_vm._v(_vm._s(_vm.score))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }